import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M12.608 18.16q-.835-.007-1.63-.29a3.8 3.8 0 0 1-1.433-.938q-.636-.653-1.01-1.733-.376-1.086-.37-2.688 0-1.494.318-2.664t.915-1.978a4.04 4.04 0 0 1 1.437-1.238q.847-.426 1.892-.426 1.097 0 1.944.431a3.66 3.66 0 0 1 1.375 1.182q.522.744.647 1.682H14.62a1.88 1.88 0 0 0-.653-1.068q-.489-.404-1.239-.404-1.21 0-1.863 1.052-.648 1.05-.654 2.886h.08q.278-.5.721-.858a3.3 3.3 0 0 1 1-.551q.562-.2 1.188-.199a3.5 3.5 0 0 1 1.835.489q.818.488 1.295 1.346.478.852.472 1.955.006 1.147-.523 2.062a3.8 3.8 0 0 1-1.471 1.432q-.944.523-2.199.517m-.011-1.706q.619 0 1.108-.3.488-.302.772-.813.284-.512.279-1.148a2.26 2.26 0 0 0-.273-1.13 2.1 2.1 0 0 0-.756-.802 2.07 2.07 0 0 0-1.102-.295 2.1 2.1 0 0 0-1.551.665 2.3 2.3 0 0 0-.636 1.58q.005.608.284 1.118.277.512.767.819a2.04 2.04 0 0 0 1.108.306"
    }, null, -1)
  ])))
}
export default { render: render }